<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
          "01:00",
          "02:00",
          "03:00",
          "04:00",
        ],
        lineData: [
          292,
          228,
          445,
          348,
          508,
          397,
          467,
          267,
          508,
          397,
          467,
          267
        ],
        barData: [
          600,
          200,
          300,
          400,
          500,
          500,
          400,
          400,
          500,
          500,
          400,
          400
        ],
        rateData: []
      },
      data: [
        {
          lineData: [
            292,
            228,
            445,
            348,
            508,
            397,
            467,
            267,
            508,
            397,
            467,
            267
          ],
          barData: [
            600,
            200,
            300,
            400,
            500,
            500,
            400,
            400,
            500,
            500,
            400,
            400
          ]
        },
        {
          lineData: [
            392,
            258,
            345,
            298,
            308,
            497,
            367,
            367,
            408,
            597,
            467,
            267
          ],
          barData: [
            400,
            300,
            400,
            300,
            600,
            300,
            500,
            300,
            400,
            600,
            500,
            200
          ]
        },
        {
          lineData: [
            292,
            428,
            345,
            548,
            308,
            397,
            367,
            567,
            208,
            297,
            367,
            367
          ],
          barData: [
            500,
            400,
            300,
            200,
            500,
            300,
            600,
            500,
            400,
            600,
            250,
            400
          ]
        },
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'device 中上'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      console.log(this.data)
      this.cdata.lineData = this.data[index].lineData
      this.cdata.barData = this.data[index].barData

      index ++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>